<router-outlet></router-outlet>
<mis-footer>
  <ng-container endSlot>
    &copy; {{ copyrightYear }} Incline-IT
  </ng-container>
</mis-footer>